module.exports = __webpack_public_path__ + "static/img/googleplay_dark.d6412a2c.png";